import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { TKey } from '~/src/dash/publicaUI';

export const IAB_CATEGORIES: {
  [key: string]: { label: string; values: { [key: string]: string } };
} = {
  IAB: {
    label: 'Empty',
    values: {},
  },
  IAB1: {
    label: 'Arts & Entertainment',
    values: {
      1: 'Books & Literature',
      2: 'Celebrity Fan/Gossip',
      3: 'Fine Art',
      4: 'Humor',
      5: 'Movies',
      6: 'Music',
      7: 'Television',
    },
  },
  IAB2: {
    label: 'Automotive',
    values: {
      1: 'Auto Parts',
      2: 'Auto Repair',
      3: 'Buying/Selling Cars',
      4: 'Car Culture',
      5: 'Certified Pre-Owned',
      6: 'Convertible',
      7: 'Coupe',
      8: 'Crossover',
      9: 'Diesel',
      10: 'Electric Vehicle',
      11: 'Hatchback',
      12: 'Hybrid',
      13: 'Luxury',
      14: 'MiniVan',
      15: 'Motorcycles',
      16: 'Off-Road Vehicles',
      17: 'Performance Vehicles',
      18: 'Pickup',
      19: 'Road-Side Assistance',
      20: 'Sedan',
      21: 'Trucks & Accessories',
      22: 'Vintage Cars',
      23: 'Wagon',
    },
  },
  IAB3: {
    label: 'Business',
    values: {
      1: 'Advertising',
      2: 'Agriculture',
      3: 'Biotech/Biomedical',
      4: 'Business Software',
      5: 'Construction',
      6: 'Forestry',
      7: 'Government',
      8: 'Green Solutions',
      9: 'Human Resources',
      10: 'Logistics',
      11: 'Marketing',
      12: 'Metals',
    },
  },
  IAB4: {
    label: 'Careers',
    values: {
      1: 'Career Planning',
      2: 'College',
      3: 'Financial Aid',
      4: 'Job Fairs',
      5: 'Job Search',
      6: 'Resume Writing/Advice',
      7: 'Nursing',
      8: 'Scholarships',
      9: 'Telecommuting',
      10: 'U.S. Military',
      11: 'Career Advice',
    },
  },
  IAB5: {
    label: 'Education',
    values: {
      1: '7-12 Education',
      2: 'Adult Education',
      3: 'Art History',
      4: 'Colledge Administration',
      5: 'College Life',
      6: 'Distance Learning',
      7: 'English as a 2nd Language',
      8: 'Language Learning',
      9: 'Graduate School',
      10: 'Homeschooling',
      11: 'Homework/Study Tips',
      12: 'K-6 Educators',
      13: 'Private School',
      14: 'Special Education',
      15: 'Studying Business',
    },
  },
  IAB6: {
    label: 'Family & Parenting',
    values: {
      1: 'Adoption',
      2: 'Babies & Toddlers',
      3: 'Daycare/Pre School',
      4: 'Family Internet',
      5: 'Parenting - K-6 Kids',
      6: 'Parenting teens',
      7: 'Pregnancy',
      8: 'Special Needs Kids',
      9: 'Eldercare',
    },
  },
  IAB7: {
    label: 'Health & Fitness',
    values: {
      1: 'Exercise',
      2: 'A.D.D.',
      3: 'AIDS/HIV',
      4: 'Allergies',
      5: 'Alternative Medicine',
      6: 'Arthritis',
      7: 'Asthma',
      8: 'Autism/PDD',
      9: 'Bipolar Disorder',
      10: 'Brain Tumor',
      11: 'Cancer',
      12: 'Cholesterol',
      13: 'Chronic Fatigue Syndrome',
      14: 'Chronic Pain',
      15: 'Cold & Flu',
      16: 'Deafness',
      17: 'Dental Care',
      18: 'Depression',
      19: 'Dermatology',
      20: 'Diabetes',
      21: 'Epilepsy',
      22: 'GERD/Acid Reflux',
      23: 'Headaches/Migraines',
      24: 'Heart Disease',
      25: 'Herbs for Health',
      26: 'Holistic Healing',
      27: 'IBS/Crohn"s Disease',
      28: 'Incest/Abuse Support',
      29: 'Incontinence',
      30: 'Infertility',
      31: 'Men"s Health',
      32: 'Nutrition',
      33: 'Orthopedics',
      34: 'Panic/Anxiety Disorders',
      35: 'Pediatrics',
      36: 'Physical Therapy',
      37: 'Psychology/Psychiatry',
      38: 'Senor Health',
      39: 'Sexuality',
      40: 'Sleep Disorders',
      41: 'Smoking Cessation',
      42: 'Substance Abuse',
      43: 'Thyroid Disease',
      44: 'Weight Loss',
      45: 'Women"s Health',
    },
  },
  IAB8: {
    label: 'Food & Drink',
    values: {
      1: 'American Cuisine',
      2: 'Barbecues & Grilling',
      3: 'Cajun/Creole',
      4: 'Chinese Cuisine',
      5: 'Cocktails/Beer',
      6: 'Coffee/Tea',
      7: 'Cuisine-Specific',
      8: 'Desserts & Baking',
      9: 'Dining Out',
      10: 'Food Allergies',
      11: 'French Cuisine',
      12: 'Health/Lowfat Cooking',
      13: 'Italian Cuisine',
      14: 'Japanese Cuisine',
      15: 'Mexican Cuisine',
      16: 'Vegan',
      17: 'Vegetarian',
      18: 'Wine',
    },
  },
  IAB9: {
    label: 'Hobbies & Interests',
    values: {
      1: 'Art/Technology',
      2: 'Arts & Crafts',
      3: 'Beadwork',
      4: 'Birdwatching',
      5: 'Board Games/Puzzles',
      6: 'Candle & Soap Making',
      7: 'Card Games',
      8: 'Chess',
      9: 'Cigars',
      10: 'Collecting',
      11: 'Comic Books',
      12: 'Drawing/Sketching',
      13: 'Freelance Writing',
      14: 'Genealogy',
      15: 'Getting Published',
      16: 'Guitar',
      17: 'Home Recording',
      18: 'Investors & Patents',
      19: 'Jewelry Making',
      20: 'Magic & Illusion',
      21: 'Needlework',
      22: 'Painting',
      23: 'Photography',
      24: 'Radio',
      25: 'Roleplaying Games',
      26: 'Sci-Fi & Fantasy',
      27: 'Scrapbooking',
      28: 'Screenwriting',
      29: 'Stamps & Coins',
      30: 'Video & Computer Games',
      31: 'Woodworking',
    },
  },
  IAB10: {
    label: 'Home & Garden',
    values: {
      1: 'Appliances',
      2: 'Entertaining',
      3: 'Environmental Safety',
      4: 'Gardening',
      5: 'Home Repair',
      6: 'Home Theater',
      7: 'Interior Decorating',
      8: 'Landscaping',
      9: 'Remodeling & Construction',
    },
  },
  IAB11: {
    label: "Law, Gov't & Politics",
    values: {
      1: 'Immigration',
      2: 'Legal Issues',
      3: 'U.S. Government Resources',
      4: 'Politics',
      5: 'Commentary',
    },
  },
  IAB12: {
    label: 'News',
    values: {
      1: 'International News',
      2: 'National News',
      3: 'Local News',
    },
  },
  IAB13: {
    label: 'Personal Finance',
    values: {
      1: 'Beginning Investing',
      2: 'Credit/Debt & Loans',
      3: 'Financial News',
      4: 'Financial Planning',
      5: 'Hedge Fund',
      6: 'Insurance',
      7: 'Investing',
      8: 'Mutual Funds',
      9: 'Options',
      10: 'Retirement Planning',
      11: 'Stocks',
      12: 'Tax Planning',
    },
  },
  IAB14: {
    label: 'Society',
    values: {
      1: 'Dating',
      2: 'Divorce Support',
      3: 'Gay Life',
      4: 'Marriage',
      5: 'Senior Living',
      6: 'Teens',
      7: 'Weddings',
      8: 'Ethnic Specific',
    },
  },
  IAB15: {
    label: 'Science',
    values: {
      1: 'Astrology',
      2: 'Biology',
      3: 'Chemistry',
      4: 'Geology',
      5: 'Paranormal Phenomena',
      6: 'Physics',
      7: 'Space/Astronomy',
      8: 'Geography',
      9: 'Botany',
      10: 'Weather',
    },
  },
  IAB16: {
    label: 'Pets',
    values: {
      1: 'Aquariums',
      2: 'Birds',
      3: 'Cats',
      4: 'Dogs',
      5: 'Large Animals',
      6: 'Reptiles',
      7: 'Veterinary Medicine',
    },
  },
  IAB17: {
    label: 'Sports',
    values: {
      1: 'Auto Racing',
      2: 'Baseball',
      3: 'Bicycling',
      4: 'Bodybuilding',
      5: 'Boxing',
      6: 'Canoeing/Kayaking',
      7: 'Cheerleading',
      8: 'Climbing',
      9: 'Cricket',
      10: 'Figure Skating',
      11: 'Fly Fishing',
      12: 'Football',
      13: 'Freshwater Fishing',
      14: 'Game & Fish',
      15: 'Golf',
      16: 'Horse Racing',
      17: 'Horses',
      18: 'Hunting/Shooting',
      19: 'Inline Skating',
      20: 'Martial Arts',
      21: 'Mountain Biking',
      22: 'NASCAR Racing',
      23: 'Olympics',
      24: 'Paintball',
      25: 'Power & Motorcycles',
      26: 'Pro Basketball',
      27: 'Pro Ice Hockey',
      28: 'Rodeo',
      29: 'Rugby',
      30: 'Running/Jogging',
      31: 'Sailing',
      32: 'Saltwater Fishing',
      33: 'Scuba Diving',
      34: 'Skateboarding',
      35: 'Skiing',
      36: 'Snowboarding',
      37: 'Surfing/Bodyboarding',
      38: 'Swimming',
      39: 'Table Tennis/Ping-Pong',
      40: 'Tennis',
      41: 'Volleyball',
      42: 'Walking',
      43: 'Waterski/Wakeboard',
      44: 'World Soccer',
    },
  },
  IAB18: {
    label: 'Style & Fashion',
    values: {
      1: 'Beauty',
      2: 'Body Art',
      3: 'Fashion',
      4: 'Jewelry',
      5: 'Clothing',
      6: 'Accessories',
    },
  },
  IAB19: {
    label: 'Technology & Computing',
    values: {
      1: '3-D Graphics',
      2: 'Animation',
      3: 'Antivirus Software',
      4: 'C/C++',
      5: 'Cameras & Camcorders',
      6: 'Cell Phones',
      7: 'Computer Certification',
      8: 'Computer Networking',
      9: 'Computer Peripherals',
      10: 'Computer Reviews',
      11: 'Data Centers',
      12: 'Databases',
      13: 'Desktop Publishing',
      14: 'Desktop Video',
      15: 'Email',
      16: 'Graphics Software',
      17: 'Home Video/DVD',
      18: 'Internet Technology',
      19: 'Java',
      20: 'JavaScript',
      21: 'Mac Support',
      22: 'MP3/MIDI',
      23: 'Net Conferencing',
      24: 'Net for Beginners',
      25: 'Network Security',
      26: 'Palmtops/PDAs',
      27: 'PC Support',
      28: 'Portable',
      29: 'Entertainment',
      30: 'Shareware/Freeware',
      31: 'Unix',
      32: 'Visual Basic',
      33: 'Web Clip Art',
      34: 'Web Design/HTML',
      35: 'Web Search',
      36: 'Windows',
    },
  },
  IAB20: {
    label: 'Travel',
    values: {
      1: 'Adventure Travel',
      2: 'Africa',
      3: 'Air Travel',
      4: 'Australia & New Zealand',
      5: 'Bed & Breakfasts',
      6: 'Budget Travel',
      7: 'Business Travel',
      8: 'By US Locale',
      9: 'Camping',
      10: 'Canada',
      11: 'Caribbean',
      12: 'Cruises',
      13: 'Eastern Europe',
      14: 'Europe',
      15: 'France',
      16: 'Greece',
      17: 'Honeymoons/Getaways',
      18: 'Hotels',
      19: 'Italy',
      20: 'Japan',
      21: 'Mexico & Central America',
      22: 'National Parks',
      23: 'South America',
      24: 'Spas',
      25: 'Theme Parks',
      26: 'Traveling with Kids',
      27: 'United Kingdom',
    },
  },
  IAB21: {
    label: 'Real Estate',
    values: {
      1: 'Apartments',
      2: 'Architects',
      3: 'Buying/Selling Homes',
    },
  },
  IAB22: {
    label: 'Shopping',
    values: {
      1: 'Contests & Freebies',
      2: 'Couponing',
      3: 'Comparison',
      4: 'Engines',
    },
  },
  IAB23: {
    label: 'Religion & Spirituality',
    values: {
      1: 'Alternative Religions',
      2: 'Atheism/Agnosticism',
      3: 'Buddhism',
      4: 'Catholicism',
      5: 'Christianity',
      6: 'Hinduism',
      7: 'Islam',
      8: 'Judaism',
      9: 'Latter-Day Saints',
      10: 'Pagan/Wiccan',
    },
  },
  IAB24: {
    label: 'Uncategorized',
    values: {},
  },
  IAB25: {
    label: 'Non-Standard Content',
    values: {
      1: 'Unmoderated UGC',
      2: 'Extreme Graphic/Explicit Violence',
      3: 'Pornography',
      4: 'Profane Content',
      5: 'Hate Content',
      6: 'Under Construction',
      7: 'Incentivized',
    },
  },
  IAB26: {
    label: 'Illegal Content',
    values: {
      1: 'Illegal Content',
      2: 'Warez',
      3: 'Spyware/Malware',
      4: 'Copyright Infringement',
    },
  },
};

export const IABCategories: { [key: string]: string } = {
  IAB: 'IAB: Empty',
  IAB1: 'IAB1: Arts & Entertainment',
  IAB2: 'IAB2: Automotive',
  IAB3: 'IAB3: Business',
  IAB4: 'IAB4: Careers',
  IAB5: 'IAB5: Education',
  IAB6: 'IAB6: Family & Parenting',
  IAB7: 'IAB7: Health & Fitness',
  IAB8: 'IAB8: Food & Drink',
  IAB9: 'IAB9: Hobbies & Interests',
  IAB10: 'IAB10: Home & Garden',
  IAB11: "IAB11: Law, Gov't & Politics",
  IAB12: 'IAB12: News',
  IAB13: 'IAB13: Personal Finance',
  IAB14: 'IAB14: Society',
  IAB15: 'IAB15: Science',
  IAB16: 'IAB16: Pets',
  IAB17: 'IAB17: Sports',
  IAB18: 'IAB18: Style & Fashion',
  IAB19: 'IAB19: Technology & Computing',
  IAB20: 'IAB20: Travel',
  IAB21: 'IAB21: Real Estate',
  IAB22: 'IAB22: Shopping',
  IAB23: 'IAB23: Religion & Spirituality',
  IAB24: 'IAB24: Uncategorized',
  IAB25: 'IAB25: Non-Standard Content',
  IAB26: 'IAB26: Illegal Content',
};

export const IABCategoryToSubCategory: { [key: string]: { [key: string]: string } } = {
  IAB: {},
  IAB1: {
    1: '1: Books & Literature',
    2: '2: Celebrity Fan/Gossip',
    3: '3: Fine Art',
    4: '4: Humor',
    5: '5: Movies',
    6: '6: Music',
    7: '7: Television',
  },
  IAB2: {
    1: '1: Auto Parts',
    2: '2: Auto Repair',
    3: '3: Buying/Selling Cars',
    4: '4: Car Culture',
    5: '5: Certified Pre-Owned',
    6: '6: Convertible',
    7: '7: Coupe',
    8: '8: Crossover',
    9: '9: Diesel',
    10: '10: Electric Vehicle',
    11: '11: Hatchback',
    12: '12: Hybrid',
    13: '13: Luxury',
    14: '14: MiniVan',
    15: '15: Mororcycles',
    16: '16: Off-Road Vehicles',
    17: '17: Performance Vehicles',
    18: '18: Pickup',
    19: '19: Road-Side Assistance',
    20: '20: Sedan',
    21: '21: Trucks & Accessories',
    22: '22: Vintage Cars',
    23: '23: Wagon',
  },
  IAB3: {
    1: '1: Advertising',
    2: '2: Agriculture',
    3: '3: Biotech/Biomedical',
    4: '4: Business Software',
    5: '5: Construction',
    6: '6: Forestry',
    7: '7: Government',
    8: '8: Green Solutions',
    9: '9: Human Resources',
    10: '10: Logistics',
    11: '11: Marketing',
    12: '12: Metals',
  },
  IAB4: {
    1: '1: Career Planning',
    2: '2: College',
    3: '3: Financial Aid',
    4: '4: Job Fairs',
    5: '5: Job Search',
    6: '6: Resume Writing/Advice',
    7: '7: Nursing',
    8: '8: Scholarships',
    9: '9: Telecommuting',
    10: '10: U.S. Military',
    11: '11: Career Advice',
  },
  IAB5: {
    1: '1: 7-12 Education',
    2: '2: Adult Education',
    3: '3: Art History',
    4: '4: Colledge Administration',
    5: '5: College Life',
    6: '6: Distance Learning',
    7: '7: English as a 2nd Language',
    8: '8: Language Learning',
    9: '9: Graduate School',
    10: '10: Homeschooling',
    11: '11: Homework/Study Tips',
    12: '12: K-6 Educators',
    13: '13: Private School',
    14: '14: Special Education',
    15: '15: Studying Business',
  },
  IAB6: {
    1: '1: Adoption',
    2: '2: Babies & Toddlers',
    3: '3: Daycare/Pre School',
    4: '4: Family Internet',
    5: '5: Parenting - K-6 Kids',
    6: '6: Parenting teens',
    7: '7: Pregnancy',
    8: '8: Special Needs Kids',
    9: '9: Eldercare',
  },
  IAB7: {
    1: '1: Exercise',
    2: '2: A.D.D.',
    3: '3: AIDS/HIV',
    4: '4: Allergies',
    5: '5: Alternative Medicine',
    6: '6: Arthritis',
    7: '7: Asthma',
    8: '8: Autism/PDD',
    9: '9: Bipolar Disorder',
    10: '10: Brain Tumor',
    11: '11: Cancer',
    12: '12: Cholesterol',
    13: '13: Chronic Fatigue Syndrome',
    14: '14: Chronic Pain',
    15: '15: Cold & Flu',
    16: '16: Deafness',
    17: '17: Dental Care',
    18: '18: Depression',
    19: '19: Dermatology',
    20: '20: Diabetes',
    21: '21: Epilepsy',
    22: '22: GERD/Acid Reflux',
    23: '23: Headaches/Migraines',
    24: '24: Heart Disease',
    25: '25: Herbs for Health',
    26: '26: Holistic Healing',
    27: '27: IBS/Crohn"s Disease',
    28: '28: Incest/Abuse Support',
    29: '29: Incontinence',
    30: '30: Infertility',
    31: '31: Men"s Health',
    32: '32: Nutrition',
    33: '33: Orthopedics',
    34: '34: Panic/Anxiety Disorders',
    35: '35: Pediatrics',
    36: '36: Physical Therapy',
    37: '37: Psychology/Psychiatry',
    38: '38: Senor Health',
    39: '39: Sexuality',
    40: '40: Sleep Disorders',
    41: '41: Smoking Cessation',
    42: '42: Substance Abuse',
    43: '43: Thyroid Disease',
    44: '44: Weight Loss',
    45: '45: Women"s Health',
  },
  IAB8: {
    1: '1: American Cuisine',
    2: '2: Barbecues & Grilling',
    3: '3: Cajun/Creole',
    4: '4: Chinese Cuisine',
    5: '5: Cocktails/Beer',
    6: '6: Coffee/Tea',
    7: '7: Cuisine-Specific',
    8: '8: Desserts & Baking',
    9: '9: Dining Out',
    10: '10: Food Allergies',
    11: '11: French Cuisine',
    12: '12: Health/Lowfat Cooking',
    13: '13: Italian Cuisine',
    14: '14: Japanese Cuisine',
    15: '15: Mexican Cuisine',
    16: '16: Vegan',
    17: '17: Vegetarian',
    18: '18: Wine',
  },
  IAB9: {
    1: '1: Art/Technology',
    2: '2: Arts & Crafts',
    3: '3: Beadwork',
    4: '4: Birdwatching',
    5: '5: Board Games/Puzzles',
    6: '6: Candle & Soap Making',
    7: '7: Card Games',
    8: '8: Chess',
    9: '9: Cigars',
    10: '10: Collecting',
    11: '11: Comic Books',
    12: '12: Drawing/Sketching',
    13: '13: Freelance Writing',
    14: '14: Genealogy',
    15: '15: Getting Published',
    16: '16: Guitar',
    17: '17: Home Recording',
    18: '18: Investors & Patents',
    19: '19: Jewelry Making',
    20: '20: Magic & Illusion',
    21: '21: Needlework',
    22: '22: Painting',
    23: '23: Photography',
    24: '24: Radio',
    25: '25: Roleplaying Games',
    26: '26: Sci-Fi & Fantasy',
    27: '27: Scrapbooking',
    28: '28: Screenwriting',
    29: '29: Stamps & Coins',
    30: '30: Video & Computer Games',
    31: '31: Woodworking',
  },
  IAB10: {
    1: '1: Appliances',
    2: '2: Entertaining',
    3: '3: Environmental Safety',
    4: '4: Gardening',
    5: '5: Home Repair',
    6: '6: Home Theater',
    7: '7: Interior Decorating',
    8: '8: Landscaping',
    9: '9: Remodeling & Construction',
  },
  IAB11: {
    1: '1: Immigration',
    2: '2: Legal Issues',
    3: '3: U.S. Government Resources',
    4: '4: Politics',
    5: '5: Commentary',
  },
  IAB12: {
    1: '1: International News',
    2: '2: National News',
    3: '3: Local News',
  },
  IAB13: {
    1: '1: Beginning Investing',
    2: '2: Credit/Debt & Loans',
    3: '3: Financial News',
    4: '4: Financial Planning',
    5: '5: Hedge Fund',
    6: '6: Insurance',
    7: '7: Investing',
    8: '8: Mutual Funds',
    9: '9: Options',
    10: '10: Retirement Planning',
    11: '11: Stocks',
    12: '12: Tax Planning',
  },
  IAB14: {
    1: '1: Dating',
    2: '2: Divorce Support',
    3: '3: Gay Life',
    4: '4: Marriage',
    5: '5: Senior Living',
    6: '6: Teens',
    7: '7: Weddings',
    8: '8: Ethnic Specific',
  },
  IAB15: {
    1: '1: Astrology',
    2: '2: Biology',
    3: '3: Chemistry',
    4: '4: Geology',
    5: '5: Paranormal Phenomena',
    6: '6: Physics',
    7: '7: Space/Astronomy',
    8: '8: Geography',
    9: '9: Botany',
    10: '10: Weather',
  },
  IAB16: {
    1: '1: Aquariums',
    2: '2: Birds',
    3: '3: Cats',
    4: '4: Dogs',
    5: '5: Large Animals',
    6: '6: Reptiles',
    7: '7: Veterinary Medicine',
  },
  IAB17: {
    1: '1: Auto Racing',
    2: '2: Baseball',
    3: '3: Bicycling',
    4: '4: Bodybuilding',
    5: '5: Boxing',
    6: '6: Canoeing/Kayaking',
    7: '7: Cheerleading',
    8: '8: Climbing',
    9: '9: Cricket',
    10: '10: Figure Skating',
    11: '11: Fly Fishing',
    12: '12: Football',
    13: '13: Freshwater Fishing',
    14: '14: Game & Fish',
    15: '15: Golf',
    16: '16: Horse Racing',
    17: '17: Horses',
    18: '18: Hunting/Shooting',
    19: '19: Inline Skating',
    20: '20: Martial Arts',
    21: '21: Mountain Biking',
    22: '22: NASCAR Racing',
    23: '23: Olympics',
    24: '24: Paintball',
    25: '25: Power & Motorcycles',
    26: '26: Pro Basketball',
    27: '27: Pro Ice Hockey',
    28: '28: Rodeo',
    29: '29: Rugby',
    30: '30: Running/Jogging',
    31: '31: Sailing',
    32: '32: Saltwater Fishing',
    33: '33: Scuba Diving',
    34: '34: Skateboarding',
    35: '35: Skiing',
    36: '36: Snowboarding',
    37: '37: Surfing/Bodyboarding',
    38: '38: Swimming',
    39: '39: Table Tennis/Ping-Pong',
    40: '40: Tennis',
    41: '41: Volleyball',
    42: '42: Walking',
    43: '43: Waterski/Wakeboard',
    44: '44: World Soccer',
  },
  IAB18: {
    1: '1: Beauty',
    2: '2: Body Art',
    3: '3: Fashion',
    4: '4: Jewelry',
    5: '5: Clothing',
    6: '6: Accessories',
  },
  IAB19: {
    1: '1: 3-D Graphics',
    2: '2: Animation',
    3: '3: Antivirus Software',
    4: '4: C/C++',
    5: '5: Cameras & Camcorders',
    6: '6: Cell Phones',
    7: '7: Computer Certification',
    8: '8: Computer Networking',
    9: '9: Computer Peripherals',
    10: '10: Computer Reviews',
    11: '11: Data Centers',
    12: '12: Databases',
    13: '13: Desktop Publishing',
    14: '14: Desktop Video',
    15: '15: Email',
    16: '16: Graphics Software',
    17: '17: Home Video/DVD',
    18: '18: Internet Technology',
    19: '19: Java',
    20: '20: JavaScript',
    21: '21: Mac Support',
    22: '22: MP3/MIDI',
    23: '23: Net Conferencing',
    24: '24: Net for Beginners',
    25: '25: Network Security',
    26: '26: Palmtops/PDAs',
    27: '27: PC Support',
    28: '28: Portable',
    29: '29: Entertainment',
    30: '30: Shareware/Freeware',
    31: '31: Unix',
    32: '32: Visual Basic',
    33: '33: Web Clip Art',
    34: '34: Web Design/HTML',
    35: '35: Web Search',
    36: '36: Windows',
  },
  IAB20: {
    1: '1: Adventure Travel',
    2: '2: Africa',
    3: '3: Air Travel',
    4: '4: Australia & New Zealand',
    5: '5: Bed & Breakfasts',
    6: '6: Budget Travel',
    7: '7: Business Travel',
    8: '8: By US Locale',
    9: '9: Camping',
    10: '10: Canada',
    11: '11: Caribbean',
    12: '12: Cruises',
    13: '13: Eastern Europe',
    14: '14: Europe',
    15: '15: France',
    16: '16: Greece',
    17: '17: Honeymoons/Getaways',
    18: '18: Hotels',
    19: '19: Italy',
    20: '20: Japan',
    21: '21: Mexico & Central America',
    22: '22: National Parks',
    23: '23: South America',
    24: '24: Spas',
    25: '25: Theme Parks',
    26: '26: Traveling with Kids',
    27: '27: United Kingdom',
  },
  IAB21: {
    1: '1: Apartments',
    2: '2: Architects',
    3: '3: Buying/Selling Homes',
  },
  IAB22: {
    1: '1: Contests & Freebies',
    2: '2: Couponing',
    3: '3: Comparison',
    4: '4: Engines',
  },
  IAB23: {
    1: '1: Alternative Religions',
    2: '2: Atheism/Agnosticism',
    3: '3: Buddhism',
    4: '4: Catholicism',
    5: '5: Christianity',
    6: '6: Hinduism',
    7: '7: Islam',
    8: '8: Judaism',
    9: '9: Latter-Day Saints',
    10: '10: Pagan/Wiccan',
  },
  IAB24: {},
  IAB25: {
    1: '1: Unmoderated UGC',
    2: '2: Extreme Graphic/Explicit Violence',
    3: '3: Pornography',
    4: '4: Profane Content',
    5: '5: Hate Content',
    6: '6: Under Construction',
    7: '7: Incentivized',
  },
  IAB26: {
    1: '1: Illegal Content',
    2: '2: Warez',
    3: '3: Spyware/Malware',
    4: '4: Copyright Infringement',
  },
};

export type IABCategory =
  | 'IAB'
  | 'IAB1'
  | 'IAB2'
  | 'IAB3'
  | 'IAB4'
  | 'IAB5'
  | 'IAB6'
  | 'IAB7'
  | 'IAB8'
  | 'IAB9'
  | 'IAB10'
  | 'IAB11'
  | 'IAB12'
  | 'IAB13'
  | 'IAB14'
  | 'IAB15'
  | 'IAB16'
  | 'IAB17'
  | 'IAB18'
  | 'IAB19'
  | 'IAB20'
  | 'IAB21'
  | 'IAB22'
  | 'IAB23'
  | 'IAB24'
  | 'IAB25'
  | 'IAB26';

export const IABCategoryToTKey: Record<IABCategory, TKey> = {
  IAB: 'IABEmpty',
  IAB1: 'IAB1ArtsAndEntertainment',
  IAB2: 'IAB2Automotive',
  IAB3: 'IAB3Business',
  IAB4: 'IAB4Careers',
  IAB5: 'IAB5Education',
  IAB6: 'IAB6FamilyAndParenting',
  IAB7: 'IAB7HealthAndFitness',
  IAB8: 'IAB8FoodAndDrink',
  IAB9: 'IAB9HobbiesAndInterests',
  IAB10: 'IAB10HomeAndGarden',
  IAB11: 'IAB11LawGovtAndPolitics',
  IAB12: 'IAB12News',
  IAB13: 'IAB13PersonalFinance',
  IAB14: 'IAB14Society',
  IAB15: 'IAB15Science',
  IAB16: 'IAB16Pets',
  IAB17: 'IAB17Sports',
  IAB18: 'IAB18StyleAndFashion',
  IAB19: 'IAB19TechnologyAndComputing',
  IAB20: 'IAB20Travel',
  IAB21: 'IAB21RealEstate',
  IAB22: 'IAB22Shopping',
  IAB23: 'IAB23ReligionAndSpirituality',
  IAB24: 'IAB24Uncategorized',
  IAB25: 'IAB25NonStandardContent',
  IAB26: 'IAB26IllegalContent',
};

export const IABSubcategoryToTKey: Record<IABCategory, { [key: number]: TKey }> = {
  IAB: {},
  IAB1: {
    1: 'IAB1BooksAndLiterature',
    2: 'IAB1CelebrityFanGossip',
    3: 'IAB1FineArt',
    4: 'IAB1Humor',
    5: 'IAB1Movies',
    6: 'IAB1Music',
    7: 'IAB1Television',
  },
  IAB2: {
    1: 'IAB2AutoParts',
    2: 'IAB2AutoRepair',
    3: 'IAB2BuyingSellingCars',
    4: 'IAB2CarCulture',
    5: 'IAB2CertifiedPreOwned',
    6: 'IAB2Convertible',
    7: 'IAB2Coupe',
    8: 'IAB2Crossover',
    9: 'IAB2Diesel',
    10: 'IAB2ElectricVehicle',
    11: 'IAB2Hatchback',
    12: 'IAB2Hybrid',
    13: 'IAB2Luxury',
    14: 'IAB2MiniVan',
    15: 'IAB2Motorcycles',
    16: 'IAB2OffRoadVehicles',
    17: 'IAB2PerformanceVehicles',
    18: 'IAB2Pickup',
    19: 'IAB2RoadSideAssistance',
    20: 'IAB2Sedan',
    21: 'IAB2TrucksAndAccessories',
    22: 'IAB2VintageCars',
    23: 'IAB2Wagon',
  },
  IAB3: {
    1: 'IAB3Advertising',
    2: 'IAB3Agriculture',
    3: 'IAB3BiotechBiomedical',
    4: 'IAB3BusinessSoftware',
    5: 'IAB3Construction',
    6: 'IAB3Forestry',
    7: 'IAB3Government',
    8: 'IAB3GreenSolutions',
    9: 'IAB3HumanResources',
    10: 'IAB3Logistics',
    11: 'IAB3Marketing',
    12: 'IAB3Metals',
  },
  IAB4: {
    1: 'IAB4CareerPlanning',
    2: 'IAB4College',
    3: 'IAB4FinancialAid',
    4: 'IAB4JobFairs',
    5: 'IAB4JobSearch',
    6: 'IAB4ResumeWritingAdvice',
    7: 'IAB4Nursing',
    8: 'IAB4Scholarships',
    9: 'IAB4Telecommuting',
    10: 'IAB4UsMilitary',
    11: 'IAB4CareerAdvice',
  },
  IAB5: {
    1: 'IAB5SevenToTwelveEducation',
    2: 'IAB5AdultEducation',
    3: 'IAB5ArtHistory',
    4: 'IAB5CollegeAdministration',
    5: 'IAB5CollegeLife',
    6: 'IAB5DistanceLearning',
    7: 'IAB5EnglishAsSecondLanguage',
    8: 'IAB5LanguageLearning',
    9: 'IAB5GraduateSchool',
    10: 'IAB5Homeschooling',
    11: 'IAB5HomeworkStudyTips',
    12: 'IAB5KSixEducators',
    13: 'IAB5PrivateSchool',
    14: 'IAB5SpecialEducation',
    15: 'IAB5StudyingBusiness',
  },
  IAB6: {
    1: 'IAB6Adoption',
    2: 'IAB6BabiesAndToddlers',
    3: 'IAB6DaycarePreSchool',
    4: 'IAB6FamilyInternet',
    5: 'IAB6ParentingKSixKids',
    6: 'IAB6ParentingTeens',
    7: 'IAB6Pregnancy',
    8: 'IAB6SpecialNeedsKids',
    9: 'IAB6Eldercare',
  },
  IAB7: {
    1: 'IAB7Exercise',
    2: 'IAB7ADD',
    3: 'IAB7AIDSHIV',
    4: 'IAB7Allergies',
    5: 'IAB7AlternativeMedicine',
    6: 'IAB7Arthritis',
    7: 'IAB7Asthma',
    8: 'IAB7AutismPDD',
    9: 'IAB7BipolarDisorder',
    10: 'IAB7BrainTumor',
    11: 'IAB7Cancer',
    12: 'IAB7Cholesterol',
    13: 'IAB7ChronicFatigueSyndrome',
    14: 'IAB7ChronicPain',
    15: 'IAB7ColdAndFlu',
    16: 'IAB7Deafness',
    17: 'IAB7DentalCare',
    18: 'IAB7Depression',
    19: 'IAB7Dermatology',
    20: 'IAB7Diabetes',
    21: 'IAB7Epilepsy',
    22: 'IAB7GERDAcidReflux',
    23: 'IAB7HeadachesMigraines',
    24: 'IAB7HeartDisease',
    25: 'IAB7HerbsForHealth',
    26: 'IAB7HolisticHealing',
    27: 'IAB7IBSCrohnsDisease',
    28: 'IAB7IncestAbuseSupport',
    29: 'IAB7Incontinence',
    30: 'IAB7Infertility',
    31: 'IAB7MensHealth',
    32: 'IAB7Nutrition',
    33: 'IAB7Orthopedics',
    34: 'IAB7PanicAnxietyDisorders',
    35: 'IAB7Pediatrics',
    36: 'IAB7PhysicalTherapy',
    37: 'IAB7PsychologyPsychiatry',
    38: 'IAB7SeniorHealth',
    39: 'IAB7Sexuality',
    40: 'IAB7SleepDisorders',
    41: 'IAB7SmokingCessation',
    42: 'IAB7SubstanceAbuse',
    43: 'IAB7ThyroidDisease',
    44: 'IAB7WeightLoss',
    45: 'IAB7WomensHealth',
  },
  IAB8: {
    1: 'IAB8AmericanCuisine',
    2: 'IAB8BarbecuesAndGrilling',
    3: 'IAB8CajunCreole',
    4: 'IAB8ChineseCuisine',
    5: 'IAB8CocktailsBeer',
    6: 'IAB8CoffeeTea',
    7: 'IAB8CuisineSpecific',
    8: 'IAB8DessertsAndBaking',
    9: 'IAB8DiningOut',
    10: 'IAB8FoodAllergies',
    11: 'IAB8FrenchCuisine',
    12: 'IAB8HealthLowfatCooking',
    13: 'IAB8ItalianCuisine',
    14: 'IAB8JapaneseCuisine',
    15: 'IAB8MexicanCuisine',
    16: 'IAB8Vegan',
    17: 'IAB8Vegetarian',
    18: 'IAB8Wine',
  },
  IAB9: {
    1: 'IAB9ArtTechnology',
    2: 'IAB9ArtsAndCrafts',
    3: 'IAB9Beadwork',
    4: 'IAB9Birdwatching',
    5: 'IAB9BoardGamesPuzzles',
    6: 'IAB9CandleAndSoapMaking',
    7: 'IAB9CardGames',
    8: 'IAB9Chess',
    9: 'IAB9Cigars',
    10: 'IAB9Collecting',
    11: 'IAB9ComicBooks',
    12: 'IAB9DrawingSketching',
    13: 'IAB9FreelanceWriting',
    14: 'IAB9Genealogy',
    15: 'IAB9GettingPublished',
    16: 'IAB9Guitar',
    17: 'IAB9HomeRecording',
    18: 'IAB9InvestorsAndPatents',
    19: 'IAB9JewelryMaking',
    20: 'IAB9MagicAndIllusion',
    21: 'IAB9Needlework',
    22: 'IAB9Painting',
    23: 'IAB9Photography',
    24: 'IAB9Radio',
    25: 'IAB9RoleplayingGames',
    26: 'IAB9SciFiAndFantasy',
    27: 'IAB9Scrapbooking',
    28: 'IAB9Screenwriting',
    29: 'IAB9StampsAndCoins',
    30: 'IAB9VideoAndComputerGames',
    31: 'IAB9Woodworking',
  },
  IAB10: {
    1: 'IAB10Appliances',
    2: 'IAB10Entertaining',
    3: 'IAB10EnvironmentalSafety',
    4: 'IAB10Gardening',
    5: 'IAB10HomeRepair',
    6: 'IAB10HomeTheater',
    7: 'IAB10InteriorDecorating',
    8: 'IAB10Landscaping',
    9: 'IAB10RemodelingAndConstruction',
  },
  IAB11: {
    1: 'IAB11Immigration',
    2: 'IAB11LegalIssues',
    3: 'IAB11USGovernmentResources',
    4: 'IAB11Politics',
    5: 'IAB11Commentary',
  },
  IAB12: {
    1: 'IAB12InternationalNews',
    2: 'IAB12NationalNews',
    3: 'IAB12LocalNews',
  },
  IAB13: {
    1: 'IAB13BeginningInvesting',
    2: 'IAB13CreditDebtAndLoans',
    3: 'IAB13FinancialNews',
    4: 'IAB13FinancialPlanning',
    5: 'IAB13HedgeFund',
    6: 'IAB13Insurance',
    7: 'IAB13Investing',
    8: 'IAB13MutualFunds',
    9: 'IAB13Options',
    10: 'IAB13RetirementPlanning',
    11: 'IAB13Stocks',
    12: 'IAB13TaxPlanning',
  },
  IAB14: {
    1: 'IAB14Dating',
    2: 'IAB14DivorceSupport',
    3: 'IAB14GayLife',
    4: 'IAB14Marriage',
    5: 'IAB14SeniorLiving',
    6: 'IAB14Teens',
    7: 'IAB14Weddings',
    8: 'IAB14EthnicSpecific',
  },
  IAB15: {
    1: 'IAB15Astrology',
    2: 'IAB15Biology',
    3: 'IAB15Chemistry',
    4: 'IAB15Geology',
    5: 'IAB15ParanormalPhenomena',
    6: 'IAB15Physics',
    7: 'IAB15SpaceAstronomy',
    8: 'IAB15Geography',
    9: 'IAB15Botany',
    10: 'IAB15Weather',
  },
  IAB16: {
    1: 'IAB16Aquariums',
    2: 'IAB16Birds',
    3: 'IAB16Cats',
    4: 'IAB16Dogs',
    5: 'IAB16LargeAnimals',
    6: 'IAB16Reptiles',
    7: 'IAB16VeterinaryMedicine',
  },
  IAB17: {
    1: 'IAB17AutoRacing',
    2: 'IAB17Baseball',
    3: 'IAB17Bicycling',
    4: 'IAB17Bodybuilding',
    5: 'IAB17Boxing',
    6: 'IAB17CanoeingKayaking',
    7: 'IAB17Cheerleading',
    8: 'IAB17Climbing',
    9: 'IAB17Cricket',
    10: 'IAB17FigureSkating',
    11: 'IAB17FlyFishing',
    12: 'IAB17Football',
    13: 'IAB17FreshwaterFishing',
    14: 'IAB17GameAndFish',
    15: 'IAB17Golf',
    16: 'IAB17HorseRacing',
    17: 'IAB17Horses',
    18: 'IAB17HuntingShooting',
    19: 'IAB17InlineSkating',
    20: 'IAB17MartialArts',
    21: 'IAB17MountainBiking',
    22: 'IAB17NASCARRacing',
    23: 'IAB17Olympics',
    24: 'IAB17Paintball',
    25: 'IAB17PowerAndMotorcycles',
    26: 'IAB17ProBasketball',
    27: 'IAB17ProIceHockey',
    28: 'IAB17Rodeo',
    29: 'IAB17Rugby',
    30: 'IAB17RunningJogging',
    31: 'IAB17Sailing',
    32: 'IAB17SaltwaterFishing',
    33: 'IAB17ScubaDiving',
    34: 'IAB17Skateboarding',
    35: 'IAB17Skiing',
    36: 'IAB17Snowboarding',
    37: 'IAB17SurfingBodyboarding',
    38: 'IAB17Swimming',
    39: 'IAB17TableTennisPingPong',
    40: 'IAB17Tennis',
    41: 'IAB17Volleyball',
    42: 'IAB17Walking',
    43: 'IAB17WaterskiWakeboard',
    44: 'IAB17WorldSoccer',
  },
  IAB18: {
    1: 'IAB18Beauty',
    2: 'IAB18BodyArt',
    3: 'IAB18Fashion',
    4: 'IAB18Jewelry',
    5: 'IAB18Clothing',
    6: 'IAB18Accessories',
  },
  IAB19: {
    1: 'IAB19ThreeDGraphics',
    2: 'IAB19Animation',
    3: 'IAB19AntivirusSoftware',
    4: 'IAB19CCPlusPlus',
    5: 'IAB19CamerasAndCamcorders',
    6: 'IAB19CellPhones',
    7: 'IAB19ComputerCertification',
    8: 'IAB19ComputerNetworking',
    9: 'IAB19ComputerPeripherals',
    10: 'IAB19ComputerReviews',
    11: 'IAB19DataCenters',
    12: 'IAB19Databases',
    13: 'IAB19DesktopPublishing',
    14: 'IAB19DesktopVideo',
    15: 'IAB19Email',
    16: 'IAB19GraphicsSoftware',
    17: 'IAB19HomeVideoDVD',
    18: 'IAB19InternetTechnology',
    19: 'IAB19Java',
    20: 'IAB19JavaScript',
    21: 'IAB19MacSupport',
    22: 'IAB19MP3MIDI',
    23: 'IAB19NetConferencing',
    24: 'IAB19NetForBeginners',
    25: 'IAB19NetworkSecurity',
    26: 'IAB19PalmtopsPDAs',
    27: 'IAB19PCSupport',
    28: 'IAB19Portable',
    29: 'IAB19Entertainment',
    30: 'IAB19SharewareFreeware',
    31: 'IAB19Unix',
    32: 'IAB19VisualBasic',
    33: 'IAB19WebClipArt',
    34: 'IAB19WebDesignHTML',
    35: 'IAB19WebSearch',
    36: 'IAB19Windows',
  },
  IAB20: {
    1: 'IAB20AdventureTravel',
    2: 'IAB20Africa',
    3: 'IAB20AirTravel',
    4: 'IAB20AustraliaAndNewZealand',
    5: 'IAB20BedAndBreakfasts',
    6: 'IAB20BudgetTravel',
    7: 'IAB20BusinessTravel',
    8: 'IAB20ByUSLocale',
    9: 'IAB20Camping',
    10: 'IAB20Canada',
    11: 'IAB20Caribbean',
    12: 'IAB20Cruises',
    13: 'IAB20EasternEurope',
    14: 'IAB20Europe',
    15: 'IAB20France',
    16: 'IAB20Greece',
    17: 'IAB20HoneymoonsGetaways',
    18: 'IAB20Hotels',
    19: 'IAB20Italy',
    20: 'IAB20Japan',
    21: 'IAB20MexicoAndCentralAmerica',
    22: 'IAB20NationalParks',
    23: 'IAB20SouthAmerica',
    24: 'IAB20Spas',
    25: 'IAB20ThemeParks',
    26: 'IAB20TravelingWithKids',
    27: 'IAB20UnitedKingdom',
  },
  IAB21: {
    1: 'IAB21Apartments',
    2: 'IAB21Architects',
    3: 'IAB21BuyingSellingHomes',
  },
  IAB22: {
    1: 'IAB22ContestsAndFreebies',
    2: 'IAB22Couponing',
    3: 'IAB22Comparison',
    4: 'IAB22Engines',
  },
  IAB23: {
    1: 'IAB23AlternativeReligions',
    2: 'IAB23AtheismAgnosticism',
    3: 'IAB23Buddhism',
    4: 'IAB23Catholicism',
    5: 'IAB23Christianity',
    6: 'IAB23Hinduism',
    7: 'IAB23Islam',
    8: 'IAB23Judaism',
    9: 'IAB23LatterDaySaints',
    10: 'IAB23PaganWiccan',
  },
  IAB24: {},
  IAB25: {
    1: 'IAB25UnmoderatedUGC',
    2: 'IAB25ExtremeGraphicExplicitViolence',
    3: 'IAB25Pornography',
    4: 'IAB25ProfaneContent',
    5: 'IAB25HateContent',
    6: 'IAB25UnderConstruction',
    7: 'IAB25Incentivized',
  },
  IAB26: {
    1: 'IAB26IllegalContentSub',
    2: 'IAB26Warez',
    3: 'IAB26SpywareMalware',
    4: 'IAB26CopyrightInfringement',
  },
};

export function IABCategoryCodeToName(name: string): string {
  if (!name.includes('-')) {
    if (name in IAB_CATEGORIES) {
      return IAB_CATEGORIES[name].label;
    }
  } else {
    const tmp = name.split('-');
    const prefix = tmp[0];
    const suffix = tmp[1];

    if (prefix in IAB_CATEGORIES) {
      let out = IAB_CATEGORIES[prefix].label;

      if (suffix in IAB_CATEGORIES[prefix].values) {
        out += ': ' + IAB_CATEGORIES[prefix].values[suffix];
      }

      return out;
    } else {
      return '?';
    }
  }

  return '?';
}

export function getAllIABCategories(): string[] {
  return Object.keys(IAB_CATEGORIES).map((val) => {
    return val;
  });
}

// Takes IAB Category Codes, and converts the codes into format: Name (Code)
// outputting
export function IABCategoryCodesToLabels(IABCategoryCodes: string, splitByString: string): string {
  // If there are not codes, just return an empty string
  if (IABCategoryCodes.length === 0) {
    return IABCategoryCodes;
  }

  // Split IABCategoryCodes by a specified character
  const IABCategories = IABCategoryCodes.split(splitByString);
  // Map over the codes, converting all codes to the format: Name(Code)
  const IABLabels = IABCategories.map((IABCategoryCode: string) => {
    const IABName = IABCategoryCodeToName(IABCategoryCode);
    return `${IABName} (${IABCategoryCode})`;
  });
  // Rejoin all the labels by a comma and space
  return IABLabels.join(', ');
}

export const generateIabCategoryOptionsList = (): ISelectOption[] => {
  try {
    const options = [] as ISelectOption[];

    // Iterate over the IAB categories and create the options
    Object.keys(IAB_CATEGORIES).forEach((categoryKey) => {
      const category = IAB_CATEGORIES[categoryKey];

      // Add the category as an option
      options.push({
        id: categoryKey,
        label: `${categoryKey}: ${category.label}`,
      });
    });

    return options;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const generateIabSubCategoryOptionsList = (IabCat: string): ISelectOption[] => {
  try {
    const options = [] as ISelectOption[];

    // Iterate over the IAB categories and create the options
    Object.keys(IAB_CATEGORIES[IabCat].values).forEach((subCategoryKey) => {
      // Add the category as an option
      const subCatLabel = IAB_CATEGORIES[IabCat].values[subCategoryKey];
      options.push({
        id: subCategoryKey,
        label: subCatLabel,
      });
    });

    return options;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
